import { createContext, useContext, useMemo, useState, type PropsWithChildren } from 'react';
import { PlayerDetailSheet } from '@/components/player/PlayerDetailSheet';

interface PlayerSheetContextValue {
  activeProfileId: string | null;
  openPlayerSheet: (profileId: string) => void;
  closePlayerSheet: () => void;
}

const PlayerSheetContext = createContext<PlayerSheetContextValue | null>(null);

export function PlayerSheetProvider({ children }: PropsWithChildren): JSX.Element {
  const [activeProfileId, setActiveProfileId] = useState<string | null>(null);

  const value = useMemo<PlayerSheetContextValue>(
    () => ({
      activeProfileId,
      openPlayerSheet: (profileId) => setActiveProfileId(profileId),
      closePlayerSheet: () => setActiveProfileId(null),
    }),
    [activeProfileId],
  );

  return (
    <PlayerSheetContext.Provider value={value}>
      {children}
      <PlayerDetailSheet profileId={activeProfileId} open={Boolean(activeProfileId)} onClose={() => setActiveProfileId(null)} />
    </PlayerSheetContext.Provider>
  );
}

export function usePlayerSheet(): PlayerSheetContextValue {
  const context = useContext(PlayerSheetContext);

  if (!context) {
    throw new Error('usePlayerSheet must be used within PlayerSheetProvider');
  }

  return context;
}
